export default __webpack_public_path__ + "static/media/Sabres.031d2646.png";